// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-wrapper {
  position: relative;
}
.notification-wrapper .notification-dropdown {
  width: 380px;
  max-height: 520px;
  overflow-y: auto;
  padding: 0;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.05);
  margin-top: 12px;
  background: #ffffff;
}
.notification-wrapper .notification-dropdown::-webkit-scrollbar {
  width: 6px;
}
.notification-wrapper .notification-dropdown::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 0 0 12px 12px;
}
.notification-wrapper .notification-dropdown::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.notification-wrapper .notification-dropdown::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.notification-wrapper .notification-dropdown__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(to bottom, #ffffff 0%, #f8fafc 100%);
  position: sticky;
  top: 0;
  z-index: 10;
}
.notification-wrapper .notification-dropdown__header .dropdown-header {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.5px;
}
.notification-wrapper .notification-dropdown__header .mark-all-read-btn {
  color: #3b82f6;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.2s ease;
  background-color: #eff6ff;
}
.notification-wrapper .notification-dropdown__header .mark-all-read-btn:hover {
  color: #2563eb;
  background-color: #dbeafe;
  text-decoration: none;
}
.notification-wrapper .notification-dropdown__footer {
  padding: 12px 20px;
  border-top: 1px solid #f1f5f9;
  background: linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%);
  position: sticky;
  bottom: 0;
  z-index: 10;
  text-align: center;
}
.notification-wrapper .notification-dropdown__footer .view-all-link {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  padding: 8px 16px;
  border-radius: 6px;
}
.notification-wrapper .notification-dropdown__footer .view-all-link:hover {
  color: #2563eb;
  background-color: #eff6ff;
}
.notification-wrapper .notification-dropdown__footer .view-all-link i {
  font-size: 16px;
  transition: transform 0.2s ease;
}
.notification-wrapper .notification-dropdown__footer .view-all-link:hover i {
  transform: translateX(4px);
}
.notification-wrapper .notification-item-wrapper {
  padding: 0;
  margin: 0;
}
.notification-wrapper .notification-item-wrapper:last-child .notification-item {
  border-bottom: none;
}
.notification-wrapper .action-item-btn {
  transition: all 0.2s ease;
}
.notification-wrapper .action-item-btn:hover {
  transform: scale(1.05);
}
.notification-wrapper .action-item-btn .badge {
  animation: bounce 0.5s ease;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}
[dir=rtl] .notification-wrapper .notification-dropdown {
  right: auto;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/notification-icon/notification-icon.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,oHAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACI;EACE,UAAA;AACN;AAEI;EACE,mBAAA;EACA,4BAAA;AAAN;AAGI;EACE,mBAAA;EACA,kBAAA;AADN;AAGM;EACE,mBAAA;AADR;AAKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,gEAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAHN;AAKM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAHR;AAMM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AAJR;AAMQ;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAJV;AASI;EACE,kBAAA;EACA,6BAAA;EACA,gEAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAPN;AASM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAPR;AASQ;EACE,cAAA;EACA,yBAAA;AAPV;AAUQ;EACE,eAAA;EACA,+BAAA;AARV;AAWQ;EACE,0BAAA;AATV;AAeE;EACE,UAAA;EACA,SAAA;AAbJ;AAeI;EACE,mBAAA;AAbN;AAiBE;EACE,yBAAA;AAfJ;AAiBI;EACE,sBAAA;AAfN;AAkBI;EACE,2BAAA;AAhBN;;AAqBA;EACE;IACE,wBAAA;EAlBF;EAoBA;IACE,2BAAA;EAlBF;AACF;AAsBE;EACE,WAAA;EACA,OAAA;AApBJ","sourcesContent":[".notification-wrapper {\r\n  position: relative;\r\n\r\n  .notification-dropdown {\r\n    width: 380px;\r\n    max-height: 520px;\r\n    overflow-y: auto;\r\n    padding: 0;\r\n    border-radius: 12px;\r\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.05);\r\n    margin-top: 12px;\r\n    background: #ffffff;\r\n\r\n    &::-webkit-scrollbar {\r\n      width: 6px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      background: #f1f5f9;\r\n      border-radius: 0 0 12px 12px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: #cbd5e1;\r\n      border-radius: 3px;\r\n\r\n      &:hover {\r\n        background: #94a3b8;\r\n      }\r\n    }\r\n\r\n    &__header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      padding: 16px 20px;\r\n      border-bottom: 1px solid #f1f5f9;\r\n      background: linear-gradient(to bottom, #ffffff 0%, #f8fafc 100%);\r\n      position: sticky;\r\n      top: 0;\r\n      z-index: 10;\r\n\r\n      .dropdown-header {\r\n        margin: 0;\r\n        font-size: 16px;\r\n        font-weight: 700;\r\n        color: #0f172a;\r\n        letter-spacing: -0.5px;\r\n      }\r\n\r\n      .mark-all-read-btn {\r\n        color: #3b82f6;\r\n        font-size: 13px;\r\n        font-weight: 600;\r\n        padding: 6px 12px;\r\n        border-radius: 6px;\r\n        text-decoration: none;\r\n        transition: all 0.2s ease;\r\n        background-color: #eff6ff;\r\n\r\n        &:hover {\r\n          color: #2563eb;\r\n          background-color: #dbeafe;\r\n          text-decoration: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    &__footer {\r\n      padding: 12px 20px;\r\n      border-top: 1px solid #f1f5f9;\r\n      background: linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%);\r\n      position: sticky;\r\n      bottom: 0;\r\n      z-index: 10;\r\n      text-align: center;\r\n\r\n      .view-all-link {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        color: #3b82f6;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        text-decoration: none;\r\n        transition: all 0.2s ease;\r\n        padding: 8px 16px;\r\n        border-radius: 6px;\r\n\r\n        &:hover {\r\n          color: #2563eb;\r\n          background-color: #eff6ff;\r\n        }\r\n\r\n        i {\r\n          font-size: 16px;\r\n          transition: transform 0.2s ease;\r\n        }\r\n\r\n        &:hover i {\r\n          transform: translateX(4px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .notification-item-wrapper {\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n    &:last-child .notification-item {\r\n      border-bottom: none;\r\n    }\r\n  }\r\n\r\n  .action-item-btn {\r\n    transition: all 0.2s ease;\r\n\r\n    &:hover {\r\n      transform: scale(1.05);\r\n    }\r\n\r\n    .badge {\r\n      animation: bounce 0.5s ease;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-3px);\r\n  }\r\n}\r\n\r\n[dir='rtl'] .notification-wrapper {\r\n  .notification-dropdown {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
